import React from 'react';
import { Redirect, Route, Switch } from '@react-router';
import { FormikProps } from 'formik';
import { ErrorSplash } from '@shared/components';
import { useContactCollectorIframeController, Contacts } from './ContactCollectorIframe.controller';
import { RoutePath, RoutesProvider, useRouterHelper } from '@shared/core';
import { TelemetryProvider } from '../guest/ContactCollectorGuest.telemetry';
import { Form, Address } from '../guest/routes';
import { JoyLogoLoader } from '@shared/components/JoyLogoLoader';

interface ContactCollectorIframeProps
  extends Readonly<{
    firebaseEventId: string;
  }> {}

export const contactCollectorIframeRoutePaths = {
  form: {
    path: 'form',
    goToPath: () => 'form'
  },
  address: {
    path: 'address',
    goToPath: () => 'address'
  }
};

const RoutesContactCollectorIframe: React.FC<{
  formik: FormikProps<Contacts>;
  isMutationLoading: boolean;
  hasMutationError: boolean;
}> = ({ formik, isMutationLoading, hasMutationError }) => {
  const routeHelpers = useRouterHelper();

  const routes: Array<RoutePath<{}>> = [
    {
      path: routeHelpers.buildPath(contactCollectorIframeRoutePaths.form.path),
      component: () => <Form formik={formik} isCollectHouseholdEnabled isIframeVersion isMutationLoading={isMutationLoading} hasMutationError={hasMutationError} />
    },
    {
      path: routeHelpers.buildPath(contactCollectorIframeRoutePaths.address.path),
      component: () => <Address formik={formik} isIframeVersion isMutationLoading={isMutationLoading} hasMutationError={hasMutationError} />
    }
  ];

  return (
    <Switch>
      {routes.map(route => (
        <Route key={route.path} path={route.path} render={route.component} exact />
      ))}
      <Redirect to={routes[0].path} />
    </Switch>
  );
};

const ContactCollectorIframe: React.FC<ContactCollectorIframeProps> = ({ firebaseEventId }) => {
  const { tAdmin, showErrorPage, isLoading, formik, isMutationLoading, hasMutationError, telemetryData } = useContactCollectorIframeController(firebaseEventId);

  if (isLoading) return <JoyLogoLoader loaderKey="contact-collector-iframe" />;
  if (showErrorPage) return <ErrorSplash customError={{ title: tAdmin.errorPageTitle(), subtitle: tAdmin.errorPageSubTitle() }} />;

  return (
    <TelemetryProvider context={telemetryData}>
      <RoutesProvider appUrl="contact-iframe/:firebaseEventId">
        <RoutesContactCollectorIframe formik={formik} isMutationLoading={isMutationLoading} hasMutationError={hasMutationError} />
      </RoutesProvider>
    </TelemetryProvider>
  );
};

export default ContactCollectorIframe;
